// extracted by mini-css-extract-plugin
module.exports = {"customColumn":"CustomColumn_customColumn__1QPwQ","test":"CustomColumn_test__2ucYH","customColumnItem":"CustomColumn_customColumnItem__1ABIY"};